/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DuplicateBuiltInDashboardRequestBody = {
  /**
   * The built-in dashboard to copy
   */
  slug: string;
};

/** @internal */
export type DuplicateBuiltInDashboardRequestBody$Outbound = {
  slug: string;
};

/** @internal */
export const DuplicateBuiltInDashboardRequestBody$outboundSchema: z.ZodMiniType<
  DuplicateBuiltInDashboardRequestBody$Outbound,
  DuplicateBuiltInDashboardRequestBody
> = z.object({
  slug: z.string(),
});

export function duplicateBuiltInDashboardRequestBodyToJSON(
  duplicateBuiltInDashboardRequestBody: DuplicateBuiltInDashboardRequestBody,
): string {
  return JSON.stringify(
    DuplicateBuiltInDashboardRequestBody$outboundSchema.parse(
      duplicateBuiltInDashboardRequestBody,
    ),
  );
}
